import React from 'react'
import { configForms } from "../../CONFIG";
import { useWidgetEditing, useReportConfig } from "../../ReportLandingContext";

const Padding16Px = ({ children }) => {
  return <div style={{ padding: "1.6rem" }}>{children}</div>;
};

// wont be needed when custom forms are used
export const WidgetConfigFormRenderer = () => {
  const { underEditWidgetIdx } = useWidgetEditing();
  const { config, setConfig } = useReportConfig();

  const ThisConfigForm = configForms[config[underEditWidgetIdx]?.comp];

  return (
    <div>
      {ThisConfigForm && (
        <Padding16Px>
          <ThisConfigForm
            thisWidgetConfig={config[underEditWidgetIdx]}
            setConfig={setConfig}
            underEditWidgetIdx={underEditWidgetIdx}
          />
        </Padding16Px>
      )}
    </div>
  );
};
